import { FILE_UPLOAD_SINGLE_FILE_UPLOAD_PROGRESS, FILE_UPLOAD_ALL_FILES_UPLOAD_START, FILE_UPLOAD_RETRY_FILES_UPLOAD_START, FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_PROGRESS, FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START, FILE_UPLOAD_RC_RETRY_FILES_UPLOAD_START } from '../actions';
import { singleFileUploadProgressReducer } from './singleFileUploadProgressReducer';
import { createFileUploadProgressState } from '../services';
import { filesUploadProgressReducer } from './filesUploadProgressReducer';
export const fileUploadProgressRootReducer = (state = createFileUploadProgressState(), action) => {
    switch (action.type) {
        case FILE_UPLOAD_ALL_FILES_UPLOAD_START:
        case FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START:
            return createFileUploadProgressState();
        case FILE_UPLOAD_RETRY_FILES_UPLOAD_START:
        case FILE_UPLOAD_RC_RETRY_FILES_UPLOAD_START:
            return filesUploadProgressReducer(state, action);
        case FILE_UPLOAD_SINGLE_FILE_UPLOAD_PROGRESS:
        case FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_PROGRESS:
            return singleFileUploadProgressReducer(state, action);
        default:
            return state;
    }
};
//# sourceMappingURL=fileUploadProgressRootReducer.js.map